import React, { useCallback, useState } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import { Field } from "formik";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import ReactSelect from "react-select";
import Title from "../title";
import CollapsibleSection from "../member/collapsibalesections";
import { MembersInfoEdit } from "../../contents/htmlContent";

export const LeadForm = (formikProps) => {
  const {
    errors,
    touched,
    values,
    setFieldValue,
    edit,
    gymId,
    loggedInGym,
    setFieldTouched,
    setErrors,
    additionalInfoErrors,
    validateAdditionalInfo,
  } = formikProps;
  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      setFieldValue("dob", date);
    } else {
      setFieldValue("dob", "");
    }
  };
  const [phoneNumber, setPhoneNumber] = React.useState(values.phone);
  React.useEffect(() => {
    if (values.dob) setSelectedDate(values.dob);
  }, []);

  React.useEffect(() => {
    if (typeof validateAdditionalInfo == "function") {
      validateAdditionalInfo(values);
    }
  }, [values, touched]);

  return (
    <>
      <div className=" bg-white card-panel">
        <div className="basic-info">
          <div className="info-title with-border">
            <Title
              title="Add Lead"
              subtitlestyle="ctf-tx-secondary"
              subtitle="Add info about the lead"
            />
          </div>
        </div>
        <div className="info trainer-info mt-4">
          <Row className="g-3">
            <Col md={6}>
              <FormGroup className="custom-inputs mb-3">
                <Field
                  type="text"
                  name="firstName"
                  id="name"
                  maxLength={50}
                  placeholder={MembersInfoEdit.firstname}
                  className={`form-control ${
                    errors.firstName && touched.firstName ? "is-invalid" : ""
                  }`}
                />
                {errors.firstName && touched.firstName && (
                  <div className="invalid-feedback">{errors.firstName}</div>
                )}
                <Label for="firstName">{MembersInfoEdit.firstname}</Label>
              </FormGroup>
            </Col>
            {/* Last Name */}
            <Col md={6}>
              <FormGroup className="custom-inputs mb-3">
                <Field
                  type="text"
                  name="lastName"
                  id="lastName"
                  maxLength={50}
                  placeholder={MembersInfoEdit.lastname}
                  className="form-control"
                />
                <Label for="lastName">{MembersInfoEdit.lastname}</Label>
              </FormGroup>
            </Col>
            {/* Gender */}
            <Col md={6}>
              <FormGroup className="custom-inputs mb-3">
                <Input
                  type="select"
                  name="gender"
                  value={values.gender}
                  onChange={(e) => setFieldValue("gender", e.target.value)}
                  className={`form-control ${
                    errors.gender && touched.gender ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </Input>
                {errors.gender && touched.gender && (
                  <div className="invalid-feedback">{errors.gender}</div>
                )}
                <Label for="gender">Gender</Label>
              </FormGroup>
            </Col>
            {/* Date of Birth */}
            <Col md={6}>
              <FormGroup className="custom-inputs mb-3">
                <Datetime
                  value={selectedDate}
                  onChange={handleDateChange}
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  inputProps={{ placeholder: "Select/type (DD/MM/YYYY)" }}
                  closeOnSelect
                  renderYear={(props, year) => (
                    <option
                      {...props}
                      style={{
                        fontSize: "12px",
                        cursor: "pointer",
                        margin: 2,
                      }}
                    >
                      {year}
                    </option>
                  )}
                />
                <Label for="date">{MembersInfoEdit.date}</Label>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="fields-radio custom-inputs mb-md-0">
                <Field
                  type="text"
                  name="email"
                  id="username"
                  placeholder={MembersInfoEdit.email}
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                />
                {additionalInfoErrors?.email &&
                touched.email &&
                touched.verifyBy ? (
                  <div className="invalid-feedback">{`${additionalInfoErrors.email}`}</div>
                ) : null}
                <Label> {MembersInfoEdit.email}</Label>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="fields-radio custom-inputs mb-md-0">
                <PhoneInput
                  international
                  defaultCountry={
                    JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                      .country
                  }
                  disabled={edit && gymId !== loggedInGym}
                  value={phoneNumber}
                  // onBlur={formikProps.handleBlur}
                  placeholder="Phone Number"
                  id="phone"
                  onChange={(value) => {
                    if (value) {
                      setPhoneNumber(value);
                      setFieldTouched("phone", true);
                      if (isValidPhoneNumber(value)) {
                        setFieldValue("phone", value);
                      } // Set the 'phone' field as touched
                      else {
                        setFieldValue("phone", "");
                        formikProps.setErrors({
                          ...errors,
                          phone: "Phone Number is Invalid",
                        });
                      }
                    }
                  }}
                  className={` ${errors.phone &&
                    touched.phone &&
                    "is-invalid"}`}
                />
                {errors.phone && touched.phone && touched.verifyBy ? (
                  <div className="invalid-feedback">{`${errors.phone}`}</div>
                ) : null}

                <Label>{MembersInfoEdit.phone}</Label>
              </FormGroup>
            </Col>
            {!values.email && !values.phone ? (
              <div className="invalid-feedback ml-4">
                Email or phone is invalid
              </div>
            ) : null}
          </Row>
        </div>
        <Row className="g-3 mt-4">
          {/* Assigned Staff */}
          <Col md={6}>
            <FormGroup className="custom-inputs mb-3">
              <ReactSelect
                name="assignedStaff"
                isDisabled={
                  JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                    .role !== "GYM"
                }
                options={formikProps?.staffList || []} // pass staff options from parent
                value={formikProps.values.assignedStaff}
                onChange={(value) =>
                  formikProps.setFieldValue("assignedStaff", value)
                }
                placeholder="Select Staff"
                classNamePrefix="react-select"
              />
              <Label>Assigned Staff</Label>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="custom-inputs mb-3">
              <ReactSelect
                name="referralSource"
                options={[
                  { label: "In Person", value: "in-person" },
                  { label: "Referral", value: "referral" },
                  { label: "Social Media", value: "socialMedia" },
                  { label: "Website", value: "web" },
                  { label: "Google", value: "google" },
                  { label: "Other", value: "other" },
                ]}
                closeMenuOnSelect={false}
                hideSelectedOptions
                value={formikProps.values.referralSource}
                onChange={(e) => formikProps.setFieldValue("referralSource", e)}
                classNamePrefix="react-select" // important for targeting
                menuPortalTarget={document.body} // ✅ This renders dropdown in body
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // make sure it's on top
              />
              <Label>{MembersInfoEdit.referralSource}</Label>
              {!values.referralSource ? (
                <div className="invalid-feedback ml-4">
                  Referral Source is required
                </div>
              ) : null}
            </FormGroup>
          </Col>
          {/* Priority */}
          <Col md={6}>
            <FormGroup className="custom-inputs mb-3">
              <Input
                type="select"
                name="priority"
                value={formikProps.values.priority}
                onChange={(e) =>
                  formikProps.setFieldValue("priority", e.target.value)
                }
                className={`form-control ${
                  errors.priority && touched.priority ? "is-invalid" : ""
                }`}
              >
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </Input>
              {errors.priority && touched.priority && (
                <div className="invalid-feedback">{errors.priority}</div>
              )}
              <Label>Priority</Label>
            </FormGroup>
          </Col>
          {/* Note */}
          <Col md={12}>
            <FormGroup className="custom-inputs mb-3">
              <Field
                as="textarea"
                name="note"
                placeholder="Add a note..."
                className={`form-control ${
                  errors.note && touched.note ? "is-invalid" : ""
                }`}
                rows={4}
              />
              {errors.note && touched.note && (
                <div className="invalid-feedback">{errors.note}</div>
              )}
              <Label>Note</Label>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </>
  );
};
